// extracted by mini-css-extract-plugin
export default {"modal-description":"ModalTimeIsUp_modal-description__4Ynsk","modal-text":"ModalTimeIsUp_modal-text__Ae4XV"};